// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3wZqBKNq1aQFAAxH2YFX3r","icon":"_3IJGHJPYlW0WTRZ7u5SCd4","active":"_3_hWsRc0wRvGDshGkPrl8K"};